import './cpgroup/style';
import FormStructure from './cpgroup/form_structure';

export default FormStructure;